import type React from 'react';
import {
  type AuthProvider,
  DEFAULT_AUTH_PROVIDERS,
  SocialAuthRow,
  type SocialProvider,
  withEmail,
} from '../../controls/social-auth-row';
import { WordsHappenModal } from '../modal';

export interface AuthOptionsModalProps {
  open: boolean;
  onClose: () => void;
  onSelect: (provider: AuthProvider) => void;
  providers?: readonly AuthProvider[];
  /**
   * The social providers that can be used (`enabledAuthProviders`); the others are shown disabled, "coming soon".
   * Email is always enabled. Every provider when left out.
   */
  enabledProviders?: readonly SocialProvider[];
  title?: React.ReactNode;
  description?: React.ReactNode;
}

/** A modal whose only job is choosing how to authenticate: one labelled button per provider. */
export const AuthOptionsModal: React.FC<AuthOptionsModalProps> = ({
  open,
  onClose,
  onSelect,
  providers = DEFAULT_AUTH_PROVIDERS,
  enabledProviders,
  title = 'Create your free account',
  description = 'Keep your scores, streaks and friends on every device.',
}) => (
  <WordsHappenModal open={open} onClose={onClose} title={title} description={description}>
    <SocialAuthRow providers={providers} enabledProviders={withEmail(enabledProviders)} onSelect={onSelect} />
  </WordsHappenModal>
);
